import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppModeService } from 'src/app/services/app-mode.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-t-c',
  templateUrl: './t-c.component.html',
  styleUrls: ['./t-c.component.css']
})
export class TCComponent {
content: string = '';

  private readonly apiUrl = environment.apiUrl + '/api/terms';

  constructor(
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public readonly appModeService: AppModeService
  ) {}

  ngOnInit() {
    const lang = this.resolveApiLang();
    this.getTermsAndConditions(lang).subscribe((res) => (this.content = res.content));
  }

  getTermsAndConditions(lang: string): Observable<{
    id: number;
    content: string;
    lang: string;
  }> {
    return this.http.get<{
      id: number;
      content: string;
      lang: string;
    }>(this.apiUrl+`/${lang}`);
  }

  private resolveApiLang(): string {
    const routeLang = this.route.snapshot.paramMap.get('lang');
    const effectiveLang = (routeLang || localStorage.getItem('lang') || 'en')
      .trim()
      .toUpperCase();
    return effectiveLang;
  }

  navigateToShop(): void {
    const currentLang = (this.route.snapshot.paramMap.get('lang') || localStorage.getItem('lang') || 'en').trim();
    this.router.navigateByUrl(`/${currentLang}/products`);
  }
}
